import { createSelector } from '@ngrx/store';
import { OnlineOrders } from '@shared/core/utils';
import { historyOrdersState } from '../root';

const orderSortFunc = (a: OLO.State.HistoryOrders.OnlineOrderItemObj, b: OLO.State.HistoryOrders.OnlineOrderItemObj) =>
    b.data.DesiredPickUpDate.localeCompare(a.data.DesiredPickUpDate);

export const getHistoryActiveOrders = createSelector(historyOrdersState, (historyOrders) =>
    historyOrders.orders.filter((order) => !!order.data && OnlineOrders.isOrderActive(order.data.Status) === true).sort(orderSortFunc),
);
